exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-icon-wrapper[data-v-18e982c2]{text-align:center;padding-top:20px}.header-icon-wrapper .v-icon[data-v-18e982c2]{font-size:5rem}.wrapper-title[data-v-18e982c2]{text-align:center;margin-top:1%;margin-bottom:1%;color:#3fa2f7}.wrapper-text[data-v-18e982c2]{text-align:center;color:#3fa2f7}.wrapper-action[data-v-18e982c2]{text-align:center;padding:20px}.wrapper-action .v-btn[data-v-18e982c2]{width:90%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-18e982c2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SimpleWarningDialog.vue
// module id = 810
// module chunks = 0